import Vue from 'vue'
import router from '../router'

import axios from 'axios'

// 配置请求的根路径
axios.defaults.baseURL = process.env.VUE_APP_baseUrl || process.env.baseUrl

// 请求拦截
axios.interceptors.request.use(config => {
    //请求头设置
    let token = Vue.prototype.$storageUtil.getAuthorityToken();
    if (token) {
        config.headers.QsAuthToken = token
    }
    return config
}, err => {
    console.log(err);
    return Promise.error(error);
})

// 响应拦截
axios.interceptors.response.use(response => {
    return Promise.resolve(response);
})

export const request = (obj) => {
    let beforeRequstRes = beforeRequst(obj);
    let method = obj.method ? obj.method.toUpperCase() == "GET" ? "GET" : "POST" : "GET";
    return axios({
        method: method,
        url: obj.url,
        data: method == "POST" ? obj.params || {} : null,
        params: method == "GET" ? obj.params || {} : null,
    }).then(res => requestSuccess(obj, beforeRequstRes, res))
        .catch(err => requestFail(obj, beforeRequstRes, err))
        .finally(res => requestComplete(obj, beforeRequstRes))
}

const beforeRequst = (obj) => {
    let res = {};
    if (obj.showLoading) {
        let loadingParam = {
            ...obj.loadingParam,
            text: obj.loadingParam && obj.loadingParam.text ? obj.loadingParam.text : null
        }
        let loading = Vue.prototype.$loading(loadingParam);
        res.loadingObj = loading;
    }
    return res;
}

const requestSuccess = (obj, beforeRequstRes, res) => {
    let resData = res.data;
    if (typeof resData != 'object') {
        resData = JSON.parse(resData);
    }
    // 请求成功
    if (resData && resData.status == 200) {
        // resData.success则请求成功，否则请求失败
        if (resData.success) {
            if (obj.showSuccessMessage) {
                Vue.prototype.$message({
                    message: obj.successMessageParams && obj.successMessageParams.message ?
                        obj.successMessageParams.message :
                        (resData.message || "操作成功"),
                    type: 'success'
                });
            }
            if (obj.showSuccessModal) {
                let successModalParams = {
                    ...obj.successModalParams,
                    title: (obj.successModalParams ?
                        obj.successModalParams.title : null) ||
                        '操作提醒',
                    content: (obj.successModalParams ?
                        obj.successModalParams.content : null) ||
                        resData.message
                };
                Vue.prototype.$alert(
                    successModalParams.content,
                    successModalParams.title,
                    {
                        ...successModalParams,
                        callback: action => {
                            return Promise.resolve(resData);
                        }
                    }
                )
            }
        } else {
            if (obj.showFailMessage) {
                Vue.prototype.$message({
                    message: obj.failMessageParams && obj.failMessageParams.message ?
                        obj.failMessageParams.message :
                        (resData.message || "操作失败"),
                    type: 'error'
                });
            }
            if (obj.showFailModal) {
                let failModalParams = {
                    ...obj.failModalParams,
                    title: (obj.failModalParams ?
                        obj.failModalParams.title : null) ||
                        '操作提醒',
                    content: (obj.failModalParams ?
                        obj.failModalParams.content : null) ||
                        resData.message,
                    type: 'error'
                };
                Vue.prototype.$alert(
                    failModalParams.content,
                    failModalParams.title,
                    {
                        ...failModalParams,
                        callback: action => {
                            return Promise.resolve(resData);
                        }
                    }
                )
            }
        }
    } else if (resData && resData.status == 999) {
        if (obj.showFailMessage) {
            Vue.prototype.$message({
                message: obj.failMessageParams && obj.failMessageParams.message ?
                    obj.failMessageParams.message :
                    (resData.message || "操作失败"),
                type: 'error'
            });
        }
        if (obj.showFailModal) {
            let failModalParams = {
                ...obj.failModalParams,
                title: (obj.failModalParams ?
                    obj.failModalParams.title : null) ||
                    '操作提醒',
                content: (obj.failModalParams ?
                    obj.failModalParams.content : null) ||
                    resData.message,
                type: 'error'
            };
            Vue.prototype.$alert(
                failModalParams.content,
                failModalParams.title,
                {
                    ...failModalParams,
                    callback: action => {
                        return Promise.resolve(resData);
                    }
                },

            )
        }
    } else if (resData && resData.status == 91105) {
        // 拒绝访问,无接口权限
        console.log(obj.url, ',拒绝访问,无接口权限');
        Vue.prototype.$alert(
            resData.message || '无权进行此操作',
            '拒绝访问',
            {
                type: 'error',
                showClose: false,
                showCancelButton: false,
                callback: action => {
                    return Promise.resolve(resData);
                }
            }
        )
    } else if (resData && (resData.status == 91001 ||
        resData.status == 91002 ||
        resData.status == 91003)) {
        console.log(obj.url, ',登录状态错误');
        if (obj.url.indexOf('user/getCurrentUserInfo') < 0) {
            Vue.prototype.$alert(
                resData.message || '登录状态错误，请重新登录',
                '登录状态错误',
                {
                    type: 'error',
                    showClose: false,
                    showCancelButton: false,
                    callback: action => {
                        // 删除已缓存标签页
                        Vue.prototype.$store.dispatch("tagsView/delAllViews");
                        router.replace('/')
                        return Promise.resolve(resData);
                    }
                }
            )
        }
    } else {
        Vue.prototype.$alert(
            resData.message || '服务器错误',
            '操作提醒',
            {
                type: 'error',
                showClose: false,
                showCancelButton: false,
                callback: action => {
                    return Promise.resolve(resData);
                }
            }
        )
    }

    if (!obj.showSuccessModal && !obj.showFailModal) {
        return Promise.resolve(resData);
    }
}

const requestFail = (obj, beforeRequstRes, res) => {
    console.log(obj.url, ',服务器错误');
    Vue.prototype.$alert(
        res.message || '接口调用失败',
        '服务请求出错',
        {
            type: 'error',
            showClose: false,
            confirmButtonText: '关闭',
            closeOnClickModal: false,
            closeOnPressEscape: false,
            callback: action => {
                return Promise.resolve(res);
            }
        }
    ).then(() => {
        return Promise.resolve(res);
    }).catch(action => {
        return Promise.resolve(res);
    })
}

const requestComplete = (obj, beforeRequstRes) => {
    if (obj.showLoading) {
        setTimeout(() => {
            beforeRequstRes.loadingObj.close();
        }, 300)
    }
}


// WEBPACK FOOTER //
// ./src/utils/request.js